import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CustomService } from '../drupal8';
import { mapStackTrace } from 'sourcemapped-stacktrace';
import { Observable, of } from 'rxjs';
declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly customService: CustomService = inject(CustomService);
  private appVersionNumber?: string | null;

  constructor() {
    this.fetchAppVersion();
  }

  logError(error: any) {
    if (!error) {
      return;
    }
    if (typeof error === 'function') {
      error = error();
    }

    const errorMessage = JSON.stringify(error.message ?? error);
    this.getStackTrace(error).subscribe((stack) => {
      this.customService.sendLog(
        'error',
        `${errorMessage}  <br> 
        <ul><li><b>stack trace</b>: <br /> ${stack} </li>
        <li> <b>url</b>: ${window.location?.href} </li>
        <li> <b>version</b>: ${this.appVersionNumber ?? '-- '}</li></ul>`
      );
    });
  }

  private getStackTrace(errorMessage: string | Error): Observable<string> {
    if (errorMessage instanceof Error) {
      return this.convertStackTrace(errorMessage.stack);
    }
    try {
      throw new Error(errorMessage as string);
    } catch (error) {
      return new Observable((observer) =>
        mapStackTrace((error as Error).stack?.split('\n').slice(2).join('\n'), (stack) =>
          observer.next(stack.join('<br />'))
        )
      );
    }
  }

  private convertStackTrace(stack?: string): Observable<string> {
    if (!stack) {
      return of('not available');
    }
    return new Observable((observer) =>
      mapStackTrace(stack, (stackMapped) => observer.next(stackMapped.join('<br />')))
    );
  }

  private fetchAppVersion(): void {
    this.appVersionNumber = environment.version;
  }
}
